import React from 'react';
import PropTypes from  'prop-types';

const SearchFormLabel = ({
    clickHandler,
    title,
}) => (
        <label onClick={() => clickHandler(title)} className="control-label">{title}:</label>
)

SearchFormLabel.propTypes = {
    clickHandler: PropTypes.func,
    title: PropTypes.string,
}

export default SearchFormLabel;


// WEBPACK FOOTER //
// ./src/components/searchForm/components/searchFormLabel.js